/// <amd-module name="Wit/DeliveryPlans/PlanSettingsPanel/PlanSettingsInterfaces" />

import { IObservableValue } from "VSS/Core/Observable";

export interface IMarkerSettingData {
    /**
     * Date to position the marker
     */
    date: IObservableValue<Date>;

    /**
     * Internal id of this setting used only in typescript
     */
    id: string;

    /**
     * Label of the marker
     */
    label: IObservableValue<string>;

    /**
     * Hex string of the color of the marker
     */
    color: IObservableValue<string>;
}
